import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MAIN_NAVIGATION, SOCIAL_MEDIA } from '../../data/constants';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const activeItem = location.pathname;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleNavClick = () => {
    closeMenu();
  };

  return (
    <nav className="navigation">
      <button 
        className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span className="nav-toggle-line"></span>
        <span className="nav-toggle-line"></span>
        <span className="nav-toggle-line"></span>
      </button>

      <div className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="nav-menu-header">
          <h3>Menu</h3>
          <button 
            className="nav-close"
            onClick={closeMenu}
            aria-label="Close navigation menu"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <ul className="nav-list">
          {MAIN_NAVIGATION.map((item, index) => (
            <li key={index} className="nav-item">
              <Link 
                to={item.href}
                className={`nav-link ${activeItem === item.href ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                <span className="nav-link-text">{item.text}</span>
                <i className="fas fa-chevron-right nav-link-icon"></i>
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-footer">
          <div className="nav-social">
            <span className="nav-social-label">Śledź nas</span>
            <div className="nav-social-links">
              {SOCIAL_MEDIA.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-social-link"
                  onClick={closeMenu}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="nav-backdrop" onClick={closeMenu}></div>
      )}
    </nav>
  );
};

export default Navigation;